











import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import index from '@/store';

@Component
export default class Items extends Vue {
    @Inject() eventBus!: Vue;

    selected = '总览';

    items: string[] = ['总览', '明细', '类别', '排行'];

    isClick(index: number) {

        return this.selected === this.items[index];
    }
    //改变选中的样式，更新 index
    changeSelected(index: number) {
        this.selected = this.items[index];

        this.eventBus.$emit('updateIndex', index)
    }
    mounted(){
        this.eventBus.$on('changeIndex',(index: number)=>{
            this.selected = this.items[index]
        })
    }
}
